module.exports = __webpack_public_path__ + "media/images/wide-default-29f1feafe2dfef90bc2570d451992565.png";